// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-panel {
    /* z-index: 9999 !important; */
    /* position: fixed; */
    /* top: 0px; */
    /* left: 0px; */
    background-color: var(--headerBackground);
    color: var(--headerColor);
    height: 36px;
    width: 100%;
    text-align: center;
    line-height: 32px;
    /* border-top: 1px solid var(--headerBorder); */
    border-bottom: 1px solid var(--headerBorder);
}

.work-panel {
    position: absolute;
    top: 37px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: var(--workPanelBackground);
}

.table-pagination {
    position: absolute;
    right: 20px;
    bottom: 0px;
    background: rgba(0,0,0,0) !important;
}

.filter {
    display: inline-block;
    min-height: 60px;
    padding: 8px 24px 0;
}

.filter .mat-form-field {
    font-size: 14px;
    width: 100%;
}

.mat-table {
    overflow: auto;
    height: 100%;
}
  
.mat-header-cell.mat-sort-header-sorted {
    /* color: black; */
}

.mat-header-row {
    top: 0;
    position: relative;
    z-index: 1;
    /* background-color: rgba(76,76,76,1); */
    /* color: white; */
    min-height: 35px;
}
.mat-header-cell {
    font-size: 14px;
}
.mat-row {
    min-height: 34px;
}
.mat-column-ontime {
    flex: 0 0 150px;
}
.mat-column-offtime {
    flex: 0 0 150px;
}
.mat-column-text {
    flex: 2 1 200px;
}
.mat-column-type {
    flex: 0 1 120px;
}
.mat-column-group {
    flex: 1 1 100px;
}

.mat-column-status {
    flex: 0 1 160px;
}
.mat-column-ack {
    flex: 0 0 60px;
}
.mat-column-acktime {
    flex: 0 0 150px;
}
.mat-column-userack {
    flex: 0 0 120px;
}
.mat-column-history {
    flex: 0 0 90px;
}

.header-tools {
    /* position: fixed; */
    /* right: 30px; */
    line-height: 32px;
}

.header-tools div {
    display: inline-block;
    padding-left: 10px;
}

.header-tools-options {
    width: 30px;
    height: 30px;
    line-height: 30px;
    vertical-align: bottom;
}

.spinner {
    position: absolute;
    top: 50%;
    left: calc(50% - 20px);
}

.spinner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
}

::ng-deep .mat-datepicker-popup {
    position: absolute;
    bottom: 50% !important;
    left: 50% !important;
    transform: translate(-50%, 50%);
}`, "",{"version":3,"sources":["webpack://./src/app/alarms/alarm-view/alarm-view.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,yCAAyC;IACzC,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;IAC/C,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,kBAAkB;IAClB,UAAU;IACV,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,+BAA+B;AACnC","sourcesContent":[".header-panel {\n    /* z-index: 9999 !important; */\n    /* position: fixed; */\n    /* top: 0px; */\n    /* left: 0px; */\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    height: 36px;\n    width: 100%;\n    text-align: center;\n    line-height: 32px;\n    /* border-top: 1px solid var(--headerBorder); */\n    border-bottom: 1px solid var(--headerBorder);\n}\n\n.work-panel {\n    position: absolute;\n    top: 37px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: var(--workPanelBackground);\n}\n\n.table-pagination {\n    position: absolute;\n    right: 20px;\n    bottom: 0px;\n    background: rgba(0,0,0,0) !important;\n}\n\n.filter {\n    display: inline-block;\n    min-height: 60px;\n    padding: 8px 24px 0;\n}\n\n.filter .mat-form-field {\n    font-size: 14px;\n    width: 100%;\n}\n\n.mat-table {\n    overflow: auto;\n    height: 100%;\n}\n  \n.mat-header-cell.mat-sort-header-sorted {\n    /* color: black; */\n}\n\n.mat-header-row {\n    top: 0;\n    position: relative;\n    z-index: 1;\n    /* background-color: rgba(76,76,76,1); */\n    /* color: white; */\n    min-height: 35px;\n}\n.mat-header-cell {\n    font-size: 14px;\n}\n.mat-row {\n    min-height: 34px;\n}\n.mat-column-ontime {\n    flex: 0 0 150px;\n}\n.mat-column-offtime {\n    flex: 0 0 150px;\n}\n.mat-column-text {\n    flex: 2 1 200px;\n}\n.mat-column-type {\n    flex: 0 1 120px;\n}\n.mat-column-group {\n    flex: 1 1 100px;\n}\n\n.mat-column-status {\n    flex: 0 1 160px;\n}\n.mat-column-ack {\n    flex: 0 0 60px;\n}\n.mat-column-acktime {\n    flex: 0 0 150px;\n}\n.mat-column-userack {\n    flex: 0 0 120px;\n}\n.mat-column-history {\n    flex: 0 0 90px;\n}\n\n.header-tools {\n    /* position: fixed; */\n    /* right: 30px; */\n    line-height: 32px;\n}\n\n.header-tools div {\n    display: inline-block;\n    padding-left: 10px;\n}\n\n.header-tools-options {\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    vertical-align: bottom;\n}\n\n.spinner {\n    position: absolute;\n    top: 50%;\n    left: calc(50% - 20px);\n}\n\n.spinner-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.6);\n    z-index: 99;\n}\n\n::ng-deep .mat-datepicker-popup {\n    position: absolute;\n    bottom: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, 50%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
